// External libraries
import React from 'react';
import { useStoreState } from 'easy-peasy';
import { func } from 'prop-types';
import {
  FloatingLabelSelect,
  LoadingElement,
} from '@checkout/react-components';

// Internal modules
import { getContent, getLocale } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

const PlaceOfBirth = props => {
  useMountLogging('PlaceOfBirth');
  const placeOfBirth = useStoreState(({ form }) => form.placeOfBirth);
  const selectOptions = useStoreState(({ api }) => {
    const { locale } = getLocale();
    return api.griffinMetadata.territories[locale];
  });

  // If the territories list is not populated yet (from the initial
  // data GraphQL call), show the loading element
  if (!selectOptions?.length) {
    return <LoadingElement />;
  }

  return (
    <FloatingLabelSelect
      id="placeOfBirth"
      label={getContent('fieldLabels.placeOfBirth')}
      name="placeOfBirth"
      required={true}
      selectOptions={selectOptions}
      {...placeOfBirth}
      {...props}
    />
  );
};

PlaceOfBirth.propTypes = {
  blurHandler: func.isRequired,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { PlaceOfBirth };
